import { AbstractCollection1g9uvtcheckwb as AbstractCollection } from './AbstractCollection.mjs';
import { equals2au1ep9vhcato as equals } from '../js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import {
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  Collection1k04j3hzsbod0 as Collection,
} from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { removeAll3cm9rh0qak2y6 as removeAll } from './MutableCollections.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractMutableCollectionClass;
function AbstractMutableCollection() {
  if (AbstractMutableCollectionClass === VOID) {
    class $ extends AbstractCollection() {
      static i6() {
        return this.j6();
      }
      w3(element) {
        this.k6();
        var iterator = this.m1();
        while (iterator.n1()) {
          if (equals(iterator.o1(), element)) {
            iterator.l6();
            return true;
          }
        }
        return false;
      }
      r1(elements) {
        this.k6();
        var modified = false;
        var _iterator__ex2g4s = elements.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (this.v(element))
            modified = true;
        }
        return modified;
      }
      w2(elements) {
        this.k6();
        var tmp = isInterface(this, MutableIterable()) ? this : THROW_CCE();
        return removeAll(tmp, (it) => elements.t1(it));
      }
      x3(elements) {
        this.k6();
        var tmp = isInterface(this, MutableIterable()) ? this : THROW_CCE();
        return removeAll(tmp, (it) => !elements.t1(it));
      }
      v3() {
        this.k6();
        var iterator = this.m1();
        while (iterator.n1()) {
          iterator.o1();
          iterator.l6();
        }
      }
      toJSON() {
        return this.toArray();
      }
      k6() {
      }
    }
    initMetadataForClass($, 'AbstractMutableCollection', VOID, VOID, [AbstractCollection(), Collection(), MutableIterable()]);
    AbstractMutableCollectionClass = $;
  }
  return AbstractMutableCollectionClass;
}
//region block: exports
export {
  AbstractMutableCollection as AbstractMutableCollections0bg6c40ztuj,
};
//endregion

//# sourceMappingURL=AbstractMutableCollectionJs.mjs.map
